export const aStarTitles = [
  '선택해주세요',
  '실망이예요',
  '별로예요',
  '괜찮아요',
  '좋아요',
  '최고예요♥',
];

export default { aStarTitles };
